import React from 'react'
import { IBannerData } from '../../exports/interfaces'

const NewsLetterBanner = (props: { newsLetterBannerData: IBannerData[] }) => {
  return (
    <section className="page-header" style={{marginTop: '71px'}}>
        <div className="page-header-bg"  
      style={{
          backgroundImage: props?.newsLetterBannerData[0]?.attributes?.Image?.data?.attributes?.url && `url(${process.env.REACT_APP_strapiUrl}${props?.newsLetterBannerData[0]?.attributes?.Image?.data?.attributes?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
        }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2>{props?.newsLetterBannerData[0]?.attributes?.Title}</h2>
            <ul className="thm-breadcrumb list-unstyled">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <span>/</span>
              </li>
              <li className="active">{props?.newsLetterBannerData[0]?.attributes?.Title}</li>
            </ul>
          </div>
        </div>
      </section>
  )
}

export default NewsLetterBanner;